import { createSlice } from '@reduxjs/toolkit';

import { CFDState, Options } from './types';

import type { CaseReducer, PayloadAction } from '@reduxjs/toolkit';

const initialState: CFDState = {
  isBrowserCFDConnected: false,
  options: {
    locale: 'en-US',
  } as Options,
};

const updateOptions: CaseReducer<CFDState, PayloadAction<Partial<CFDState['options']>>> = (
  state,
  action,
) => {
  state.options = {
    ...state.options,
    ...action.payload,
  };
};

const updateBrowserCFDConnection: CaseReducer<
  CFDState,
  PayloadAction<CFDState['isBrowserCFDConnected']>
> = (state, action) => {
  state.isBrowserCFDConnected = action.payload;
};

const cfdSlice = createSlice({
  name: 'cfd',
  initialState,
  reducers: {
    updateOptions,
    updateBrowserCFDConnection,
  },
});

const { actions, reducer } = cfdSlice;
export { reducer as cfdReducer, actions as cfdActions };
